import type { GenericTrackingEvent } from '@packages/tracking';
import { useTracking } from '@packages/tracking';
import { useCallback } from 'react';

export interface GtmCheckoutEvent extends GenericTrackingEvent {
  event: 'ga_event';
  eventAction: EventAction;
  eventCategory: EventCategory;
}

/* could be done better with String Literal Types in typescript 4.1 */
export type EventCategory =
  | 'cart'
  | 'basket_article'
  | 'basket_LoyalityProgram'
  | 'articlechange'
  | 'deliverycosts'
  | 'directorder'
  | 'aplus'
  | 'login'
  | 'captcha'
  | 'resetpassword'
  | 'registration'
  | 'captcha_registration'
  | 'passwordstrength'
  | 'newcustomer_registration_guest' // maybe unused
  | 'newcustomer_registration_eu' // maybe unused
  | 'shipping'
  | 'parcelshop'
  | 'addressbook'
  | 'payment'
  | 'installmentcalculator'
  | 'valuta'
  | 'valutapromotion'
  | 'payment_invoice_valuta'
  | 'payment_installment_valuta'
  | 'intermediate_valutapromotion'
  | 'directdebit'
  | 'checkAndOrder'
  | 'checkandorder_article'
  | 'checkandorder_Installmentpromotion'
  | 'checkandorder_LoyalityProgram'
  | 'thanks'
  | 'thanks_PaymentInAdvance'
  | 'orderconfirmation'
  | 'changecustomertype'
  | 'paymentprotection'
  | 'payment_paymentprotection'
  | 'intermediate_paymentprotection'
  | 'premiumsite'
  | 'paymentschedule'
  | 'creditcard'
  | 'basket_DOF'
  | 'Intermediate_LoyalityProgram'
  | 'Payment_Methods_PaymentInAdvance'
  | 'progressbar_Navigation_LastChecktoBasket'
  | 'Checkbox_checkandorder_AgbZustimmung'
  | 'scrid'
  | 'choicelayer_checkAndOrder'
  | 'choicelayer_options'
  | 'choicelayer_decision';

export type EventAction =
  | 'addToBasket'
  | 'addToWishlist'
  | 'change'
  | 'click'
  | 'delete'
  | 'order'
  | 'select'
  | 'unselect'
  | 'submit'
  | 'view'
  | 'viewPage'
  | 'viewLayer'
  | 'read';

/**
 * This hook provides a easy to use function for tracking events in the fragment.
 * For further documentation see https://confluence.empirie.com/display/ORI/Tracking+-+Doku
 * @returns (eventCategory: EventCategory, isLayer: boolean = false) => void
 */
export const useEventTracking = () => {
  const dispatch = useTracking();
  return useCallback(
    (eventCategory: EventCategory, eventAction: EventAction) =>
      dispatch<GtmCheckoutEvent>({
        event: 'ga_event',
        eventAction,
        eventCategory,
      }),
    [dispatch],
  );
};
